module.exports = __webpack_public_path__ + "static/socialdesirabilitybias-1476d847d5eb9ed8e70e3af8a8d689d9.png";